import { trackPageView, initScrollAnimations } from '../lib';

export function initTermsOfServicePage(): void {
  console.log('Initializing terms of service page');
  initScrollAnimations();
  trackPageView();
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initTermsOfServicePage);
}
